module.exports = __webpack_public_path__ + "app-store.png";